import { render, staticRenderFns } from "./quesTowStep.vue?vue&type=template&id=23f0af6f&scoped=true"
import script from "./quesTowStep.vue?vue&type=script&lang=js"
export * from "./quesTowStep.vue?vue&type=script&lang=js"
import style0 from "./quesTowStep.vue?vue&type=style&index=0&id=23f0af6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f0af6f",
  null
  
)

export default component.exports